import {
    ready
} from '~/core'

ready('components', '.components', components => {
    const items = components.querySelectorAll('.components-component')
    const examples = components.querySelectorAll('.components-example')
    const printCode = () => {
        examples.forEach((example => {
            const exampleCode = example.innerHTML.replace(/</g, "&lt;")
            let codeBlock = example.closest('.components-component').querySelector('.components-code')
            codeBlock.innerHTML = exampleCode
        }))
    }
    const toggleCode = () => {
        items.forEach((item => {
            const toggle = item.querySelector('.components-preToggle')
            toggle.addEventListener("click", function () {
                item.classList.toggle('is-expanded')
            })
        }))
    }

    printCode()
    toggleCode()
});